module.exports = __webpack_public_path__ + "static/media/home_video.f8465a1f.mp4";